export function Girador({ tamano = 16 }: { tamano?: number }) {
  return <span className="girador" style={{ width: tamano, height: tamano }} aria-hidden="true" />;
}
